export default function isVideoFile(filename = '') {
  if (typeof filename !== 'string') return false;
  const clean = filename.split('?')[0].toLowerCase();
  return /\.(mp4|m4v|webm|ogg|ogv|mov|flv|3gp|3g2|avi|mkv)$/i.test(clean);
}
// export default function isVideoFile(filename) {
//   // const VIDEO_FORMATS = /(\.mp4|\.mov)$/i; // Only match .mp4 and .mov files
//   const VIDEO_FORMATS =
//     /(\.mp4|\.m4v|\.webm|\.ogg|\.ogv|\.mov|\.flv|\.3gp|\.3g2)$/i; // Uncomment this line to match other video formats
//   return VIDEO_FORMATS.test(filename);
// }
